import { heroFeatured, heroSideCards } from "@/mocks/resources";

export default function Hero() {
  return (
    <section id="home" className="pt-24 pb-14 md:pt-28 md:pb-20 bg-background-50">
      <div className="px-4 md:px-8">
        <div className="anim-fade-up mb-8 md:mb-10">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100 text-accent-900 text-xs md:text-sm font-medium">
            <i className="ri-fire-line"></i>
            视频 · 写真 · 图片 一站浏览
          </span>
          <h1 className="mt-5 font-heading text-3xl md:text-5xl font-black leading-tight text-foreground-950">
            色虎视频与写真图片资源
            <br className="hidden md:block" />
            在线观看与收藏
          </h1>
          <p className="mt-5 max-w-3xl text-sm md:text-base leading-relaxed text-foreground-700">
            色虎视频资源站聚合视频、写真与图片三类内容，支持在线观看与快速查找。你可以在此浏览
            <strong className="font-semibold text-foreground-900"> 色虎视频</strong>、
            <strong className="font-semibold text-foreground-900"> 色虎写真</strong>、
            <strong className="font-semibold text-foreground-900"> 色虎图片</strong>
            ，并按主题标签筛选，一站式获取最近更新的资源内容。
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-5">
          <a
            href="#videos"
            className="group relative lg:col-span-2 rounded-lg overflow-hidden bg-foreground-900 h-[300px] md:h-[460px] cursor-pointer"
          >
            <img
              src={heroFeatured.cover}
              alt="色虎视频资源：晨雾高原湖泊航拍纪实封面"
              title="色虎视频资源在线观看"
              className="w-full h-full object-cover object-top anim-soft-zoom group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/30 to-transparent"></div>
            <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium">
                <i className="ri-star-fill"></i>
                {heroFeatured.subtitle}
              </span>
              <h2 className="mt-3 font-heading text-xl md:text-3xl font-bold text-background-50">
                {heroFeatured.title}
              </h2>
              <p className="mt-2 max-w-2xl text-xs md:text-sm leading-relaxed text-background-200">
                {heroFeatured.desc}
              </p>
              <div className="mt-4 flex items-center gap-4 text-xs md:text-sm text-background-200">
                <span className="flex items-center gap-1.5">
                  <i className="ri-play-circle-line"></i>
                  {heroFeatured.meta}
                </span>
                <span className="flex items-center gap-1.5 text-background-50 font-medium">
                  立即观看
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </span>
              </div>
            </div>
          </a>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-4 md:gap-5">
            {heroSideCards.map((card) => (
              <a
                key={card.title}
                href={card.tag === "写真" ? "#photobooks" : card.tag === "图片" ? "#gallery" : "#videos"}
                className="group relative rounded-lg overflow-hidden bg-foreground-900 h-[180px] md:h-[140px] cursor-pointer"
              >
                <img
                  src={card.cover}
                  alt={`色虎${card.tag}资源：${card.title}`}
                  title={`${card.title} 在线观看`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 to-transparent"></div>
                <div className="absolute inset-x-0 bottom-0 p-4 flex items-end justify-between gap-2">
                  <div>
                    <span className="text-[11px] px-2 py-0.5 rounded-full bg-secondary-600 text-background-50">
                      {card.tag}
                    </span>
                    <h3 className="mt-2 font-heading text-base font-bold text-background-50">
                      {card.title}
                    </h3>
                  </div>
                  <span className="text-xs text-background-200 whitespace-nowrap">{card.meta}</span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}